import { render } from "./DotsVertical.vue?vue&type=template&id=78570fa6"
import script from "./DotsVertical.vue?vue&type=script&lang=js"
export * from "./DotsVertical.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__